let calendar_filters = document.querySelectorAll('.form_term');
let calender_country = document.getElementById('form_term_country');
let calender_year = document.getElementById('form_term_year');
let calender_month = document.getElementById('form_term_month');
let calender_tourtype = document.getElementById('form_term_tourtype');

//On click trigger for the calendar filters
for (let i = 0; i < calendar_filters.length; i++) {
    let filter = calendar_filters[i];
    filter.onchange = function () {

        // get clean url
        let clean_url = '//' + location.host + location.pathname;
        let url_var = [];

        // get selected values of all filters
        if (calender_country && calender_country.value) {
            url_var.push('tourcountry=' + calender_country.value);
        }
        if (calender_year && calender_year.value) {
            url_var.push('touryear=' + calender_year.value);
        }
        if (calender_month && calender_month.value) {
            url_var.push('tourmonth=' + calender_month.value);
        }
        if (calender_tourtype && calender_tourtype.value) {
            url_var.push('tourtype=' + calender_tourtype.value);
        }

        // reload to new url with correct values as url parms
        let url_string = url_var.join('&');
        if (url_string) {
            clean_url = clean_url + '?' + url_string;
        }
        // Reload
        window.location.href = clean_url;

    };
}

jQuery(document).ready(function () {
    jQuery('#form_term_review').select2();
    jQuery('#form_term_filter').select2();
});